import views from '@/views/';

export default [
  {
    component: views.drugControl.drugInfo,
    label: '药品信息管理',
    path: 'druginfo',
    name: 'drugInfo',
  },
  {
    component: views.drugControl.purchase,
    label: '出入库管理',
    path: 'purchase',
    name: 'purchase',
  },
  {
    component: views.drugControl.stock,
    label: '库存管理',
    path: 'stock',
    name: 'stock',
  },
  {
    component: views.drugControl.flowQuery,
    label: '流向查询',
    path: 'flowquery',
    name: 'flowQuery',
  },
  {
    component: views.drugControl.inventory,
    label: '盘点管理',
    path: 'inventory',
    name: 'inventory',
  },
  {
    component: views.drugControl.validityWarn,
    label: '效期提醒',
    path: 'validity',
    name: 'validityWarn',
  },
  {
    component: views.drugControl.stockWarn,
    label: '库存预警',
    path: 'stockwarn',
    name: 'stockWarn',
  },
  {
    component: views.drugControl.drugDetail,
    label: '药品详情',
    path: 'drugdetail',
    name: 'drugDetail',
    menuHidden: true,
  },
  {
    component: views.drugControl.quickEdit,
    label: '快速编辑',
    path: 'quick',
    name: 'quickEdit',
    menuHidden: true,
  },
  {
    component: views.drugControl.purchaseDetail,
    label: '入库详情',
    path: 'purchasedetail',
    name: 'purchaseDetail',
    menuHidden: true,
  },
  {
    component: views.drugControl.purchaseRetreat,
    label: '退货',
    path: 'purchaseretreat',
    name: 'purchaseRetreat',
    menuHidden: true,
  },
  {
    component: views.drugControl.purchaseRetreatDetail,
    label: '退货详情',
    path: 'retreatdetail/:id',
    name: 'retreatDetail',
    menuHidden: true,
  },
  {
    component: views.drugControl.newInventory,
    label: '新增盘点',
    path: 'newinventory',
    name: 'newInventory',
    menuHidden: true,
  },
  {
    component: views.drugControl.inventoryDetail,
    label: '盘点详情',
    path: 'inventorydetail',
    name: 'inventoryDetail',
    menuHidden: true,
  },
  {
    component: views.drugControl.inventoryQuery,
    label: '盘点确认',
    path: 'inventoryquery',
    name: 'inventoryQuery',
    menuHidden: true,
  },
  // {
  //   component: views.drugControl.template,
  //   label: '模板',
  //   path: 'template',
  //   name: 'template',
  // },
];
